import FireBaseUtils from '@/libs/FirebaseUtils';
import firebase from 'firebase/app';
import 'firebase/firestore';
import store from '@/store';
import UserStatus from '@/models/UserStatusModel';
import Utils from '@/libs/Utils';

export default class UserApi {
  static async init() {
    const db = firebase.firestore();
    const user = FireBaseUtils.safeGetUser();

    await db.collection('users').doc(user.uid).set(Utils.toObject(new UserStatus()));
  }

  static async load() {
    const db = firebase.firestore();
    const user = FireBaseUtils.safeGetUser();
    const docSnp = await db.collection('users').doc(user.uid).get();

    const doc = docSnp.data();

    if (doc) {
      store.commit('updateUserStatus', doc);
    }
  }
}
